<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <div class="chat-wrapper">
        <app-overlay-loader v-if="preloader" />
        <div class="chat-messages">
          <div class="message-header">
            <div class="contact-title">
              <h4 class="mb-0">{{ $t("job_chat") }}</h4>
            </div>
            <div class="contact-user">
              <!-- <div class="avatars-w-40">
                                <div class="no-img rounded-circle avatar-shadow">RW</div>
                            </div> -->
              <app-avatar
                :title="userList.full_name"
                class="mr-2"
                avatar-class="avatars-w-40"
                :img="''"
                :alt-text="$t('not_found')"
              />
            </div>
          </div>
          <div class="message-body">
            <div v-for="chat in allcomment" :key="chat.id">
              <div
                class="message"
                v-if="chat.user_id != user_id"
                style="
                  flex-direction: inherit;
                  display: flex;
                  align-items: center;
                "
              >
                <!-- <app-avatar
                                    :title="chat.user.full_name"
                                    class="mr-2"
                                    avatar-class="avatars-w-40"
                                    :img="''"
                                    :alt-text="$t('not_found')"
                                /> -->

                <div
                  class="text"
                  style="margin-left: 10px; border-radius: 15px 15px 15px 0px"
                >
                  <span> {{ chat.body }}</span> <br />
                  <small> {{ chat.created_at | formatDate }} </small>
                </div>
              </div>
              <div class="message" v-if="chat.user_id == user_id">
                <!-- <app-avatar
                                    :title="chat.user.full_name"
                                    class="mr-2"
                                    avatar-class="avatars-w-40"
                                    :img="''"
                                    :alt-text="$t('not_found')"
                                /> -->

                <div class="text">
                  <span> {{ chat.body }}</span> <br />
                  <small> {{ chat.created_at | formatDate }} </small>
                </div>
              </div>
            </div>
            <div class="message" v-for="message in messages" :key="message">
              <div class="avatars-w-40">
                <div>
                  <!-- <app-avatar
                                        :title="userList.full_name"
                                        class="mr-2"
                                        avatar-class="avatars-w-40"
                                        :img="''"
                                        :alt-text="$t('not_found')"
                                    /> -->
                  <!-- <div class="no-img rounded-circle avatar-shadow">JD</div> -->
                </div>
              </div>
              <div class="text">
                <span>{{ message }}</span>
              </div>
            </div>
          </div>
          <div class="message-editor">
            <div class="message-input">
              <div class="message-input-group">
                <app-input
                  id="description"
                  placeholder="Type something here..."
                  type="text"
                  v-model="inputs.comment"
                  v-on:keydown.enter.prevent="submit"
                />
                <div class="message-input-append">
                  <a href="#" class="btn btn-send" @click.prevent="submit">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-send size-15"
                    >
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  COMPANY_JOB_CHAT,
  COMPANY_JOB_CHAT_STORE,
} from "../../../../../Config/ApiUrl";
import {
  axiosPost,
  axiosPatch,
  axiosGet,
} from "../../../../../Helpers/AxiosHelper";
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],
  props: {
    comments: {
      type: Array,
    },
    id: Number,
  },
  data() {
    return {
      inputs: {
        job_id: "",
      },
      messages: [],
      allcomment: [],
      user_id: "",
      preloader: true,
    };
  },
  methods: {
    GetComments() {
      // this.preloader = true;
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      // 
      // let id = split[6].split("?")[0];
      let id = this.$attrs['props'].id;
      axiosGet(COMPANY_JOB_CHAT + "/" + id)
        .then((res) => {
          this.allcomment = res.data.chat;
          this.user_id = res.data.user_id;
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    submit() {
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      // 
      // let id = split[6].split("?")[0];
      let id = this.$attrs['props'].id;
      this.inputs.job_id = id;
      axiosPost(COMPANY_JOB_CHAT_STORE, this.inputs)
        .then((res) => {
          this.messages.push(res.data);
          this.inputs = {};
        })
        .catch((error) => {
          this.$toastr.e(error.data.message);
        });
    },
    afterSuccess(response) {
      this.$toastr.e(response.data.message);
    },
  },
  mounted() {
    setTimeout(() => {
      this.GetComments();
    }, 3000);
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
